import ApiResponse from '../core/ApiResponse';
import { HttpErrors } from '../core/HttpErrors';
import { ResponseData } from '../core/ResponseData';
import { ToggleItem } from '../core/ToggleItem';

/**
 * A service for handling feature toggles.
 */
class FeatureToggleService {
  /**
   * Retrieves a feature toggle item by its ID from a list of feature toggle items.
   *
   * @param featureToggleList - The list of feature toggle items to search through.
   * @param id - The ID of the feature toggle item to retrieve.
   * @returns - A Promise resolving to an ApiResponse object containing the requested feature toggle item (if found), along with metadata about the response.
   */
  getFeatureToggleItem = async (featureToggleList: ToggleItem[], id: string): Promise<ApiResponse<ToggleItem | undefined>> => {
    const item = featureToggleList.find((i) => i.id === id);

    const response: ResponseData<ToggleItem | undefined> = {
      content: item,
      statusCode: item ? HttpErrors.OK : HttpErrors.NOT_FOUND,
      success: !!item,
      responseCode: item ? 'OK' : 'NOT FOUND',
    };

    return Promise.resolve(ApiResponse.fromData(response));
  };
}
export default new FeatureToggleService();
